<template>
  <img :src="url" class="relative flex-shrink-0" />
</template>

<script>
export default {
  name: "BlGif",
  props: {
    gif: {
      type: String,
      required: true
    }
  },
  computed: {
    url() {
      if (!window || !window.location) return "";
      return `${window.location.origin}/static/gifs/${this.gif}.gif`;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/BlGif.vue